module.exports = __webpack_public_path__ + "img/account-arrow-up.399a1b52.svg";